import React from "react";
import { useDateTime } from "../components/Helper/DateTime";
function withDateTime(Component) {
  return function WrappedComponent(props) {
    const dateTime = useDateTime();
    return <Component {...props} dateTime={dateTime} />;
  };
}
export default withDateTime;
